module.exports = __webpack_public_path__ + "img/eye.198708e9.svg";